import { Button, Col, Form, Row, Stack } from "react-bootstrap";
import { useContext, useState } from "react";
import { LayerImportState } from "../../../../constant/LayerImportState";
import { LayerContext } from "../LayerContext";
import ImportTable from "../ImportTable/ImportTable";
import { useOpenRoadsService } from "../../../../hooks";

const OpenRoadsLayer = () => {
  const openRoadsService = useOpenRoadsService();
  const [revertInProgress, setRevertInProgress] = useState(false);

  const value = useContext(LayerContext);
  const { layerInfo, setImportPage } = value!;

  const onRevert = () => {
    setRevertInProgress(true);
    openRoadsService
      .Revert()
      .then(() => {
        setImportPage(1);
        setRevertInProgress(false);
      })
      .catch(() => {});
  };

  return (
    <>
      <Stack gap={4} className="mb-3">
        <Row>
          <Col sm={6}>
            <Row>
              <Form.Label>
                {layerInfo.revertToImportDate && (
                  <>
                    Rollback to import{" "}
                    {layerInfo.revertToImportDate.toFormat("dd-MM-yyyy")}
                  </>
                )}
                {!layerInfo.revertToImportDate && <>Rollback Unavailable</>}
              </Form.Label>
              <div>
                <Button
                  disabled={!layerInfo.revertToImportDate || revertInProgress}
                  onClick={() => onRevert()}
                  className="w-50">
                  Rollback
                </Button>
              </div>
            </Row>
          </Col>
        </Row>
      </Stack>
      <ImportTable />
    </>
  );
};

export default OpenRoadsLayer;
